import template from 'url-template';

import {
    FETCH_CLIENT_ENERGY_EQUIPMENT,
    FETCH_CLIENT_ENERGY_KPI,
    FETCH_EQUIPMENT_AVOIDED_COSTS,
    FETCH_EQUIPMENT_FUTURE_SAVINGS,
    FETCH_ENERGY_EQUIPMENT,
    FETCH_ENERGY_SITES,
    FETCH_EQUIPMENT_ENERGY_DATA,
    FETCH_EQUIPMENT_ENERGY_KPI,
    FETCH_ENERGY_EQUIPMENT_SUMMARY,
    FETCH_ENERGY_EQUIPMENT_GROUP,
    FETCH_SITE_AVOIDED_COSTS,
    FETCH_SITE_ENERGY_DATA,
    FETCH_SITE_ENERGY_KPI,
    FETCH_SITE_FUTURE_SAVINGS
} from '../actions/actionTypes';

import _ from 'lodash';

import moment from 'moment';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { setBobLoading } from './bobActions';
import { handleNetworkError } from './applicationMessageActions';

const SiteEnergyUrl = template.parse('/sites/energy-data{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const EquipmentEnergyUrl = template.parse('/equipment/energy-data{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const EquipmentEnergyKpiUrl = template.parse('/equipment/energy-kpi{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const SiteEnergyKpiUrl = template.parse('/sites/energy-kpi{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const EquipmentViewUrl = template.parse('/companies/{companyId}/equipment-energy-view{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const AvoidedCostsUrl = template.parse('/equipment/energy-avoided-Cost{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const SiteViewUrl = template.parse('/companies/{companyId}/site-energy-view{?ClientId,SiteId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const ClientEnergyKpiUrl = template.parse('/clients/energy-kpi{?ClientId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const EquipmentFutureSavingsUrl = template.parse('/equipment/energy-future-saving{?ClientId,SiteId,EquipmentId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const SiteFutureSavingsUrl = template.parse('/sites/energy-future-saving{?ClientId,SiteId,EnergyTabView,EnergyUnit,Interval,TimeIntervalUnit,StartDate,EndDate,AllRecords}');
const UpdateSensorAttributesUrl = template.parse('/customattributes');
const EnergyByEquipemtTypeUrl = template.parse('sites/energy-data/summary/groupby/equipmenttype{?SiteId,StartDate,EndDate}');

export const fetchClientEnergyKpis = (ClientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchClientEnergyKpis'));

    try {
        const response = await k2aBaseApi.get(
            ClientEnergyKpiUrl.expand({
                ClientId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_CLIENT_ENERGY_KPI,
            payload: payload
        });
        dispatch(setBobLoading('FetchClientEnergyKpis'));
    } catch (error) {
        dispatch(setBobLoading('FetchClientEnergyKpis'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEquipmentEnergyData = (ClientId, SiteId, EquipmentId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchEquipmentEnergyData'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentEnergyUrl.expand({
                ClientId,
                SiteId,
                EquipmentId,
                ...options
            }),
            header
        );

        let payload = _.get(response, 'data', []);
        if (!_.isEmpty(payload)) {
            payload.energyTimeSeries.currentTimeSeries = payload.energyTimeSeries.currentTimeSeries.reverse();
            payload.energyTimeSeries.priorTimeSeries = payload.energyTimeSeries.priorTimeSeries.reverse();
        }

        dispatch({
            type:    FETCH_EQUIPMENT_ENERGY_DATA,
            payload: payload
        });
        dispatch(setBobLoading('FetchEquipmentEnergyData'));
    } catch (error) {
        dispatch(setBobLoading('FetchEquipmentEnergyData'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEquipmentEnergyKpis = (ClientId, SiteId, EquipmentId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchEquipmentEnergyKpis'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentEnergyKpiUrl.expand({
                ClientId,
                SiteId,
                EquipmentId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_EQUIPMENT_ENERGY_KPI,
            payload: payload
        });
        dispatch(setBobLoading('FetchEquipmentEnergyKpis'));
    } catch (error) {
        dispatch(setBobLoading('FetchEquipmentEnergyKpis'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEnergyEquipment = (companyId, ClientId, SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();


    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = options.energyHog ? moment(getState().dashboard.dashboardStartTimeStamp).subtract(1,'days').local().format():moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }
    delete options.energyHog;

    dispatch(setBobLoading('FetchSiteEnergyData'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentViewUrl.expand({
                companyId,
                ClientId,
                SiteId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_ENERGY_EQUIPMENT,
            payload: payload
        });

        dispatch(setBobLoading('FetchSiteEnergyData'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteEnergyData'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchClientEnergyEquipment = (companyId, ClientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchClientEnergyEquipment'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentViewUrl.expand({
                companyId,
                ClientId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_CLIENT_ENERGY_EQUIPMENT,
            payload: payload
        });

        dispatch(setBobLoading('FetchClientEnergyEquipment'));
    } catch (error) {
        dispatch(setBobLoading('FetchClientEnergyEquipment'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEnergySites = (companyId, ClientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchClientEnergySites'));

    try {
        const response = await k2aBaseApi.get(
            SiteViewUrl.expand({
                companyId,
                ClientId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_ENERGY_SITES,
            payload: payload
        });

        dispatch(setBobLoading('FetchClientEnergySites'));
    } catch (error) {
        dispatch(setBobLoading('FetchClientEnergySites'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEquipmentAvoidedCosts = (ClientId, SiteId, EquipmentId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchEquipmentAvoidedCosts'));

    try {
        const response = await k2aBaseApi.get(
            AvoidedCostsUrl.expand({
                ClientId,
                SiteId,
                EquipmentId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', []);

        dispatch({
            type:    FETCH_EQUIPMENT_AVOIDED_COSTS,
            payload: payload
        });
        dispatch(setBobLoading('FetchEquipmentAvoidedCosts'));
    } catch (error) {
        dispatch(setBobLoading('FetchEquipmentAvoidedCosts'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEquipmentFutureSavings = (ClientId, SiteId, EquipmentId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchEquipmentFutureSavings'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentFutureSavingsUrl.expand({
                ClientId,
                SiteId,
                EquipmentId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', []);

        dispatch({
            type:    FETCH_EQUIPMENT_FUTURE_SAVINGS,
            payload: payload
        });
        dispatch(setBobLoading('FetchEquipmentFutureSavings'));
    } catch (error) {
        dispatch(setBobLoading('FetchEquipmentFutureSavings'));
        dispatch(handleNetworkError(error));
    }

};

export const fetchEnergyEquipmentSummary = (companyId, ClientId, SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();


    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = options.energyHog ? moment(getState().dashboard.dashboardStartTimeStamp).subtract(1,'days').local().format():moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }
    delete options.energyHog;

    dispatch(setBobLoading('FetchSiteEnergyData'));

    try {
        const response = await k2aBaseApi.get(
            EquipmentViewUrl.expand({
                companyId,
                ClientId,
                SiteId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_ENERGY_EQUIPMENT_SUMMARY,
            payload: payload
        });

        dispatch(setBobLoading('FetchSiteEnergyData'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteEnergyData'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchEnergyEquipmentGroupSummary = (SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();


    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = options.energyHog ? moment(getState().dashboard.dashboardStartTimeStamp).subtract(1,'days').local().format():moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }
    delete options.energyHog;

    dispatch(setBobLoading('FetchSiteEnergyGroupData'));

    try {
        const response = await k2aBaseApi.get(
            EnergyByEquipemtTypeUrl.expand({
                SiteId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_ENERGY_EQUIPMENT_GROUP,
            payload: payload
        });

        dispatch(setBobLoading('FetchSiteEnergyGroupData'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteEnergyGroupData'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchSiteEnergyData = (ClientId, SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = options.energyHog ? moment(getState().dashboard.dashboardStartTimeStamp).subtract(1,'days').local().format():moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }
    delete options.energyHog;
    dispatch(setBobLoading('FetchSiteEnergyData'));

    try {
        const response = await k2aBaseApi.get(
            SiteEnergyUrl.expand({
                ClientId,
                SiteId,
                ...options
            }),
            header
        );

        let payload = _.get(response, 'data', []);
        if (!_.isEmpty(payload)) {
            payload.energyTimeSeries.currentTimeSeries = payload.energyTimeSeries.currentTimeSeries.reverse();
            payload.energyTimeSeries.priorTimeSeries = payload.energyTimeSeries.priorTimeSeries.reverse();
        }

        dispatch({
            type:    FETCH_SITE_ENERGY_DATA,
            payload: payload
        });
        dispatch(setBobLoading('FetchSiteEnergyData'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteEnergyData'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchSiteEnergyKpis = (ClientId, SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchSiteEnergyKpis'));

    try {
        const response = await k2aBaseApi.get(
            SiteEnergyKpiUrl.expand({
                ClientId,
                SiteId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', {});

        dispatch({
            type:    FETCH_SITE_ENERGY_KPI,
            payload: payload
        });
        dispatch(setBobLoading('FetchSiteEnergyKpis'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteEnergyKpis'));
        dispatch(handleNetworkError(error));
    }
};

export const fetchSiteAvoidedCosts = (ClientId, SiteId, EquipmentId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    try {
        const response = await k2aBaseApi.get(
            AvoidedCostsUrl.expand({
                ClientId,
                SiteId,
                EquipmentId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', []);

        dispatch({
            type:    FETCH_SITE_AVOIDED_COSTS,
            payload: payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchSiteFutureSavings = (ClientId, SiteId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    if (getState().dashboard.dashboardIsCurrentTimeStamp) {
        options.StartDate = moment(getState().dashboard.dashboardStartTimeStamp).local().format();
        options.EndDate = moment(getState().dashboard.dashboardEndTimeStamp).local().format();
    }

    dispatch(setBobLoading('FetchSiteFutureSavings'));

    try {
        const response = await k2aBaseApi.get(
            SiteFutureSavingsUrl.expand({
                ClientId,
                SiteId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data', []);

        dispatch({
            type:    FETCH_SITE_FUTURE_SAVINGS,
            payload: payload
        });
        dispatch(setBobLoading('FetchSiteFutureSavings'));
    } catch (error) {
        dispatch(setBobLoading('FetchSiteFutureSavings'));
        dispatch(handleNetworkError(error));
    }

};

export const updateSensorAttributes = body => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseApi.patch(
            UpdateSensorAttributesUrl.expand({}),
            body,
            header
        );

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setEquipmentEnergyData = data => async (dispatch, getState) => {
    dispatch({
        type:    FETCH_EQUIPMENT_ENERGY_DATA,
        payload: data
    });
};

export const setSiteEnergyData = data => async (dispatch, getState) => {
    dispatch({
        type:    FETCH_SITE_ENERGY_DATA,
        payload: data
    });
};
